import ProductItemsSlider from 'components/ProductItemsSlider/ProductItemsSlider';
import { useStore } from 'features/home/store/homeSlice';
import { IProductItem } from 'features/home/types/homeTypes';
import React, { useEffect, useState } from 'react';
import { filterVisibility } from 'submodules/OrderCore';
import { shallow } from 'zustand/shallow';

export interface IRecommendedCategoriesProps {
  title?: string;
  dot?: boolean;
}

const RecommendedCategories = ({ title, dot }: IRecommendedCategoriesProps) => {
  const { categories, restaurant, inactiveMenu } = useStore(
    (state) => ({
      categories: state.homeState.categories,
      restaurant: state.homeState.restaurant,
      inactiveMenu: state.homeState.inactiveMenu,
    }),
    shallow,
  );
  const [recommendedItems, setRecommendedItems] = useState<IProductItem[]>([]);
  const [productItems, setProductItems] = useState<IProductItem[]>([]);

  useEffect(() => {
    let currentTemp = recommendedItems.filter((item) => {
      return item.active && filterVisibility(item);
    });
    setProductItems(currentTemp);
  }, [inactiveMenu, recommendedItems, restaurant]);

  useEffect(() => {
    let recommendedItems: IProductItem[] = [];

    categories.length > 0 &&
      categories
        .filter((cate) => filterVisibility(cate))
        .forEach((cat) => {
          recommendedItems = [
            ...recommendedItems,
            ...cat.items.filter((item) => item.tags.includes('Recommended')),
          ];
        });
    setRecommendedItems(recommendedItems);
  }, [categories]);

  return (
    <>
      {productItems.length > 0 && (
        <ProductItemsSlider
          showTitle={true}
          restaurant={restaurant}
          productItems={recommendedItems}
          inactiveMenu={inactiveMenu}
          title={title}
          dot={dot}
        />
      )}
    </>
  );
};

export default RecommendedCategories;
